import { GeneratorCountryZoneCountryModel, GeneratorCountryZoneModel } from '@/Models';

export function addZone(countryZones: GeneratorCountryZoneCountryModel[], model: GeneratorCountryZoneModel) {
  if (isTopLevel(model)) {
    addCountryZone(countryZones, model);
  } else {
    const countryZone = countryZoneUtils.countryZoneById(model.parentId, countryZones);
    if (countryZone) {
      countryZone.zoneLevels.push(model);
    }
  }
}

export function updateZone(
  countryZones: GeneratorCountryZoneCountryModel[],
  model: GeneratorCountryZoneModel,
  selectedUuid = '',
) {
  if (isTopLevel(model)) {
    updateCountryZone(countryZones, model, selectedUuid);
  } else {
    const countryZone = countryZoneUtils.countryZoneById(model.parentId, countryZones);
    if (countryZone) {
      countryZone.zoneLevels = countryZone.zoneLevels.map((zoneLevel) => {
        return shouldUpdateZoneLevel(zoneLevel, model, selectedUuid) ? model : zoneLevel;
      });
    }
  }
}

export function deleteZone(countryZones: GeneratorCountryZoneCountryModel[], modelId: string | number) {
  deleteCountryZone(countryZones, modelId);
  deleteZoneLevel(countryZones, modelId);
}

function shouldUpdateZoneLevel(
  zoneLevel: GeneratorCountryZoneModel,
  model: GeneratorCountryZoneModel,
  selectedUuid: string,
) {
  if (selectedUuid !== '') {
    return zoneLevel.uuid === selectedUuid;
  }
  return zoneLevel.id === model.id;
}

export function isTopLevel(x: GeneratorCountryZoneModel): boolean {
  return !x.parentId || x.parentId === '';
}

function countryZoneById(countryZoneId: string | number, zones: GeneratorCountryZoneCountryModel[]) {
  for (const zone of zones) {
    for (const logistic of zone.logistics) {
      for (const countryZone of logistic.countryZones) {
        if (countryZone.id == countryZoneId) {
          return countryZone;
        }
      }
    }
  }

  return null;
}

function addCountryZone(countryZones: GeneratorCountryZoneCountryModel[], model: GeneratorCountryZoneModel) {
  const countryZone = countryZones.find((x) => x.country === model.countryCode);

  if (countryZone) {
    let logistic = countryZone.logistics.find((x) => {
      return x.logisticApiType == model.logisticApiType;
    });

    if (logistic) {
      logistic.countryZones.push(model);
    } else {
      logistic = {
        country: model.countryCode,
        logisticApiType: model.logisticApiType,
        countryZones: [model],
      };
      countryZone.logistics.push(logistic);
    }
  }
}

function updateCountryZone(
  countryZones: GeneratorCountryZoneCountryModel[],
  model: GeneratorCountryZoneModel,
  selectedUuid = '',
) {
  const countryZone = countryZones.find((x) => x.country === model.countryCode);

  if (countryZone) {
    const logistic = countryZone.logistics.find((x) => {
      return x.logisticApiType == model.logisticApiType;
    });

    if (logistic) {
      logistic.countryZones = logistic.countryZones.map((zoneLevel) => {
        return shouldUpdateZoneLevel(zoneLevel, model, selectedUuid) ? model : zoneLevel;
      });
    }
  }
}

function deleteCountryZone(countryZones: GeneratorCountryZoneCountryModel[], modelId: string | number) {
  countryZones.forEach((x) => {
    x.logistics.forEach((y) => {
      y.countryZones = y.countryZones.filter((z) => z.id !== modelId);
    });

    x.logistics = x.logistics.filter((y) => y.countryZones.length !== 0);
  });
}

function deleteZoneLevel(zones: GeneratorCountryZoneCountryModel[], modelId: string | number) {
  zones.forEach((x) => {
    x.logistics.forEach((y) =>
      y.countryZones.forEach((z) => {
        z.zoneLevels = z.zoneLevels.filter((level) => level.id != modelId);
      }),
    );
  });
}

export const countryZoneUtils = {
  addZone,
  updateZone,
  deleteZone,
  countryZoneById,
  isTopLevel,
};
